<template>
  <div class="color-line">
    <div
      class="background-box"
      :style="{
        // top: smallTop,
        height: `${barHeight}vw`,
      }"
    ></div>
    <div
      class="color-box"
      :class="{
        left: position === 'left',
        right: position === 'right',
      }"
      :style="{
        width: smallWidth,
      }"
    ></div>
  </div>
</template>

<script>
// 柱状图，不包含数字
export default {
  props: {
    position: {
      type: String,
      default: 'left',
    },
    maxValue: {
      default: 100,
    },
    value: {
      default: 0,
    },
    barHeight: {
      type: Number,
      default: 0.556,
    },
  },
  data() {
    return {}
  },
  computed: {
    smallWidth() {
      const reg = /%$/g
      let value = 0
      if (this.maxValue * 1 === 0) {
        return 0
      }
      if (reg.exec(this.value)) {
        value =
          (this.value.replace(reg, '') / this.maxValue) * 100 > 100
            ? 100
            : (this.value.replace(reg, '') / this.maxValue) * 100
      } else {
        value =
          (this.value / this.maxValue) * 100 > 100
            ? 100
            : (this.value / this.maxValue) * 100
      }
      return value + '%'
    },
    // smallTop() {
    //   if (this.smallHeight === 16) {
    //     return 0
    //   } else {
    //     return '1px'
    //   }
    // },
  },
}
</script>

<style lang="scss" scoped>
.color-line {
  position: relative;
  height: 100%;
  .background-box {
    position: absolute;
    z-index: 10;
    top: 0;
    left: 0;
    right: 0;
    background-color: var(--mixtmt_subColor_main);
    border-radius: 0.278vw;
  }
  .color-box {
    position: absolute;
    z-index: 20;
    top: 0;
    bottom: 0;
    border-radius: 0.278vw;
    transition: width 0.3s linear;
  }
  .left {
    /* 客队颜色 */
    left: 0;
    background-color: var(--mixtmt_combatBar1_2);
  }
  .right {
    /* 主队颜色 */
    right: 0;
    background-color: var(--mixtmt_combatBar1_1);
  }
}
</style>
